// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Sub-category Studio (redesign): modern list matching Category Studio. Design tokens w/ fallbacks. */

.SubCategoryStudio-toolbar-rNVys {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: justify;
      -ms-flex-pack: justify;
          justify-content: space-between;
  gap: 16px;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
  margin-bottom: 16px;
}

.SubCategoryStudio-filters-FIujc {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 10px;
  -ms-flex-wrap: wrap;
      flex-wrap: wrap;
}

.SubCategoryStudio-searchInput-qij3X {
  min-width: 240px;
}

.SubCategoryStudio-filterSelect-h2tZo {
  min-width: 150px;
}

.SubCategoryStudio-list-znOCl {
  list-style: none;
  margin: 0;
  padding: 0;
}

.SubCategoryStudio-row-yqme_ {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 12px;
  padding: 10px 14px;
  margin-bottom: 8px;
  background: #ffffff;
  background: var(--white-color, #ffffff);
  border: 1px solid #e4e4e4;
  border: 1px solid var(--border-color, #e4e4e4);
  border-radius: 12px;
  border-radius: var(--radius-2, 12px);
  -webkit-transition: border-color 0.15s ease, -webkit-box-shadow 0.15s ease;
  transition: border-color 0.15s ease, -webkit-box-shadow 0.15s ease;
  transition: box-shadow 0.15s ease, border-color 0.15s ease;
  transition: box-shadow 0.15s ease, border-color 0.15s ease, -webkit-box-shadow 0.15s ease;
}

.SubCategoryStudio-row-yqme_:hover {
  border-color: #d32f2f;
  border-color: var(--primary-bg, #d32f2f);
  -webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.SubCategoryStudio-thumb-ZGFyV {
  width: 40px;
  height: 40px;
  border-radius: 6px;
  border-radius: var(--radius-1, 6px);
  -o-object-fit: cover;
     object-fit: cover;
  -ms-flex-negative: 0;
      flex-shrink: 0;
}

.SubCategoryStudio-thumbPlaceholder-_GJux {
  width: 40px;
  height: 40px;
  border-radius: 6px;
  border-radius: var(--radius-1, 6px);
  -ms-flex-negative: 0;
      flex-shrink: 0;
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  font-weight: 700;
  color: #fff;
  text-transform: uppercase;
  background: #d32f2f;
  background: var(--primary-bg, #d32f2f);
}

.SubCategoryStudio-nameCol-p7UNh {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column;
  -webkit-box-flex: 1;
      -ms-flex: 1 1;
          flex: 1 1;
  min-width: 120px;
}

.SubCategoryStudio-name-CwJTf {
  font-weight: 600;
  color: #181817;
  color: var(--content-text, #181817);
}

.SubCategoryStudio-meta-lliPA {
  font-size: 12px;
  color: #909090;
  color: var(--content-text-secondary, #909090);
}

.SubCategoryStudio-catBadge-M9eDP {
  font-size: 11px;
  color: #606060;
  color: var(--content-text-secondary, #606060);
  border: 1px solid #e4e4e4;
  border: 1px solid var(--border-color, #e4e4e4);
  border-radius: 999px;
  padding: 2px 10px;
  white-space: nowrap;
}

.SubCategoryStudio-statusSelect-W4Jzu {
  min-width: 120px;
}

.SubCategoryStudio-statusActive-OVxEA {
  color: #03a83b;
  font-weight: 600;
}

.SubCategoryStudio-statusInactive-wz4Az {
  color: #ff4c4c;
  font-weight: 600;
}

.SubCategoryStudio-actions-Gc4a3 {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  gap: 6px;
}

.SubCategoryStudio-actionLink-waQ1G,
.SubCategoryStudio-actionBtn-_tLm8 {
  display: -webkit-inline-box;
  display: -ms-inline-flexbox;
  display: inline-flex;
  -webkit-box-align: center;
      -ms-flex-align: center;
          align-items: center;
  -webkit-box-pack: center;
      -ms-flex-pack: center;
          justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 6px;
  border-radius: var(--radius-1, 6px);
  border: 1px solid #e4e4e4;
  border: 1px solid var(--border-color, #e4e4e4);
  background: #ffffff;
  background: var(--white-color, #ffffff);
  cursor: pointer;
  color: #181817;
  color: var(--content-text, #181817);
  text-decoration: none;
}

.SubCategoryStudio-actionLink-waQ1G:hover,
.SubCategoryStudio-actionBtn-_tLm8:hover {
  border-color: #d32f2f;
  border-color: var(--primary-bg, #d32f2f);
  color: #d32f2f;
  color: var(--primary-bg, #d32f2f);
}

.SubCategoryStudio-icon-ckNLC {
  width: 16px;
  height: 16px;
}

.SubCategoryStudio-empty-HiXiU {
  padding: 32px;
  text-align: center;
  color: #606060;
  color: var(--content-text-secondary, #606060);
}
`, "",{"version":3,"sources":["webpack://./src/components/SubCategory/SubCategoryList/SubCategoryStudio.css"],"names":[],"mappings":"AAAA,sGAAsG;;AAEtG;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;EAC9B,SAAS;EACT,mBAAe;MAAf,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,SAAS;EACT,mBAAe;MAAf,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,mBAAuC;EAAvC,uCAAuC;EACvC,yBAA8C;EAA9C,8CAA8C;EAC9C,mBAAoC;EAApC,oCAAoC;EACpC,0EAA0D;EAA1D,kEAA0D;EAA1D,0DAA0D;EAA1D,yFAA0D;AAC5D;;AAEA;EACE,qBAAwC;EAAxC,wCAAwC;EACxC,iDAAyC;UAAzC,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAmC;EAAnC,mCAAmC;EACnC,oBAAiB;KAAjB,iBAAiB;EACjB,oBAAc;MAAd,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAmC;EAAnC,mCAAmC;EACnC,oBAAc;MAAd,cAAc;EACd,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,mBAAsC;EAAtC,sCAAsC;AACxC;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,4BAAsB;EAAtB,6BAAsB;MAAtB,0BAAsB;UAAtB,sBAAsB;EACtB,mBAAO;MAAP,aAAO;UAAP,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAmC;EAAnC,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,cAA6C;EAA7C,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,cAA6C;EAA7C,6CAA6C;EAC7C,yBAA8C;EAA9C,8CAA8C;EAC9C,oBAAoB;EACpB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAa;EAAb,oBAAa;EAAb,aAAa;EACb,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;;EAEE,2BAAoB;EAApB,2BAAoB;EAApB,oBAAoB;EACpB,yBAAmB;MAAnB,sBAAmB;UAAnB,mBAAmB;EACnB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAmC;EAAnC,mCAAmC;EACnC,yBAA8C;EAA9C,8CAA8C;EAC9C,mBAAuC;EAAvC,uCAAuC;EACvC,eAAe;EACf,cAAmC;EAAnC,mCAAmC;EACnC,qBAAqB;AACvB;;AAEA;;EAEE,qBAAwC;EAAxC,wCAAwC;EACxC,cAAiC;EAAjC,iCAAiC;AACnC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,cAA6C;EAA7C,6CAA6C;AAC/C","sourcesContent":["/* Sub-category Studio (redesign): modern list matching Category Studio. Design tokens w/ fallbacks. */\n\n.toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  flex-wrap: wrap;\n  margin-bottom: 16px;\n}\n\n.filters {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.searchInput {\n  min-width: 240px;\n}\n\n.filterSelect {\n  min-width: 150px;\n}\n\n.list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 10px 14px;\n  margin-bottom: 8px;\n  background: var(--white-color, #ffffff);\n  border: 1px solid var(--border-color, #e4e4e4);\n  border-radius: var(--radius-2, 12px);\n  transition: box-shadow 0.15s ease, border-color 0.15s ease;\n}\n\n.row:hover {\n  border-color: var(--primary-bg, #d32f2f);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n}\n\n.thumb {\n  width: 40px;\n  height: 40px;\n  border-radius: var(--radius-1, 6px);\n  object-fit: cover;\n  flex-shrink: 0;\n}\n\n.thumbPlaceholder {\n  width: 40px;\n  height: 40px;\n  border-radius: var(--radius-1, 6px);\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 700;\n  color: #fff;\n  text-transform: uppercase;\n  background: var(--primary-bg, #d32f2f);\n}\n\n.nameCol {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-width: 120px;\n}\n\n.name {\n  font-weight: 600;\n  color: var(--content-text, #181817);\n}\n\n.meta {\n  font-size: 12px;\n  color: var(--content-text-secondary, #909090);\n}\n\n.catBadge {\n  font-size: 11px;\n  color: var(--content-text-secondary, #606060);\n  border: 1px solid var(--border-color, #e4e4e4);\n  border-radius: 999px;\n  padding: 2px 10px;\n  white-space: nowrap;\n}\n\n.statusSelect {\n  min-width: 120px;\n}\n\n.statusActive {\n  color: #03a83b;\n  font-weight: 600;\n}\n\n.statusInactive {\n  color: #ff4c4c;\n  font-weight: 600;\n}\n\n.actions {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.actionLink,\n.actionBtn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border-radius: var(--radius-1, 6px);\n  border: 1px solid var(--border-color, #e4e4e4);\n  background: var(--white-color, #ffffff);\n  cursor: pointer;\n  color: var(--content-text, #181817);\n  text-decoration: none;\n}\n\n.actionLink:hover,\n.actionBtn:hover {\n  border-color: var(--primary-bg, #d32f2f);\n  color: var(--primary-bg, #d32f2f);\n}\n\n.icon {\n  width: 16px;\n  height: 16px;\n}\n\n.empty {\n  padding: 32px;\n  text-align: center;\n  color: var(--content-text-secondary, #606060);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"toolbar": `SubCategoryStudio-toolbar-rNVys`,
	"filters": `SubCategoryStudio-filters-FIujc`,
	"searchInput": `SubCategoryStudio-searchInput-qij3X`,
	"filterSelect": `SubCategoryStudio-filterSelect-h2tZo`,
	"list": `SubCategoryStudio-list-znOCl`,
	"row": `SubCategoryStudio-row-yqme_`,
	"thumb": `SubCategoryStudio-thumb-ZGFyV`,
	"thumbPlaceholder": `SubCategoryStudio-thumbPlaceholder-_GJux`,
	"nameCol": `SubCategoryStudio-nameCol-p7UNh`,
	"name": `SubCategoryStudio-name-CwJTf`,
	"meta": `SubCategoryStudio-meta-lliPA`,
	"catBadge": `SubCategoryStudio-catBadge-M9eDP`,
	"statusSelect": `SubCategoryStudio-statusSelect-W4Jzu`,
	"statusActive": `SubCategoryStudio-statusActive-OVxEA`,
	"statusInactive": `SubCategoryStudio-statusInactive-wz4Az`,
	"actions": `SubCategoryStudio-actions-Gc4a3`,
	"actionLink": `SubCategoryStudio-actionLink-waQ1G`,
	"actionBtn": `SubCategoryStudio-actionBtn-_tLm8`,
	"icon": `SubCategoryStudio-icon-ckNLC`,
	"empty": `SubCategoryStudio-empty-HiXiU`
};
module.exports = ___CSS_LOADER_EXPORT___;
